import React, { useEffect, useState } from "react";
import {
  PaymentElement,
  useStripe,
  useElements
} from "@stripe/react-stripe-js";

export default function StripePaymentForm(props) {

    const stripe = useStripe();
    const elements = useElements();

    const [message, setMessage] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
    if (!stripe) {
        return;
    }

    const clientSecret = new URLSearchParams(window.location.search).get(
        "payment_intent_client_secret"
    );

    if (!clientSecret) {
        return;
    }

    
    stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
        switch (paymentIntent.status) {
            case "succeeded":
                setMessage("Payment succeeded!");
            break;
            case "processing":
                setMessage("Your payment is processing.");
            break;
            case "requires_payment_method":
                setMessage("Your payment was not successful, please try again.");
            break;
            default:
                setMessage("Something went wrong.");
            break;
        }
    });
  }, [stripe]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
            return;
        }
        setIsLoading(true);
        stripe.confirmPayment({
            elements,
            redirect: "if_required",
        }).then(function(result) {
            if (result.error) {
                setMessage(result.error.message);
            }else{
                setMessage("Payment succeeded!");
                //want to let the user know something is happening instead of just snapping straight back to etb submission thanks. 
                setTimeout(() => {  props.setStripeStatus(true); }, 1500);
            } 
        });
        setIsLoading(false);
    };

  return (
    <form id="payment-form" onSubmit={handleSubmit}>
        <PaymentElement id="payment-element" />
        {message && <div id="payment-message">{message}</div>}
        <button disabled={isLoading || !stripe || !elements} id="submit">
            <span id="button-text">
                {isLoading ? <div className="spinner" id="spinner"></div> : "Pay now"}
            </span>
        </button>
    </form>
  );
}